import { styled } from '@mui/material/styles'
import { TextField } from '@mui/material'
import theme from 'lib/theme'

export const StyledInput = styled(TextField, {
  shouldForwardProp: (props) =>
    props !== 'width' && props !== 'mb' && props !== 'flexBasis',
})<{
  width?: string
  mb?: string
  flexBasis?: string
}>(({ width, mb, flexBasis }) => ({
  marginBottom: mb || theme.spacing(6),
  width: width ?? '100%',
  ...(flexBasis && { flexBasis }),
  paddingLeft: 0,
  '& .MuiFormHelperText-root': {
    fontSize: '10px',
    position: 'absolute',
    left: '-7px',
    bottom: '-16px',
  },
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
  '& .MuiFilledInput-input': {
    padding: theme.spacing(1),
    textFillColor: theme.palette.text.primary,
    textOverflow: 'ellipsis',
  },
  '& .MuiFilledInput-root': {
    backgroundColor: theme.palette.action.hover,
    padding: 0,
  },
  '& .Mui-disabled': {
    backgroundColor: 'transparent',
  },
  '&&': {
    mb: mb || theme.spacing(6),
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    width: '100%',
  },
}))
